import React from 'react';

export const WalletsLinks = ({ wallets }) => {
  return (wallets &&
    <div>
      {wallets.map((wallet) => (
        <a key={wallet} className="hover:bg-gray-400 mr-1 text-xs" href={`https://usdt.tokenview.io/en/address/${wallet}`} target="_blank" rel="noreferrer">{wallet.slice(0, 5)}</a>
      ))}
    </div>
  );
};
